// src/pages/Receiver/GHG/hooks/useGhgMeta.js
import { useMemo } from "react";
import { useInventorySnapshot } from "../../../../hooks/useInventorySnapshot";

export function useGhgMeta() {
  // Always enabled because this should be light (“meta”), not the big snapshot
  const { data, loading, error } = useInventorySnapshot(true, true, "meta");

  const materialEmissionsMap = useMemo(() => {
    return data?.filters?.materialEmissionsMap || {};
  }, [data]);

  const donorOptions = useMemo(() => {
    const donors = data?.filters?.donors;
    if (Array.isArray(donors)) {
      return donors.map(String).filter(Boolean).sort((a, b) => a.localeCompare(b));
    }
    return [];
  }, [data]);

  const materialOptions = useMemo(() => {
    // If backend provides a list, use it, else fall back to emissions-map keys
    const mats = data?.filters?.materials;
    if (Array.isArray(mats) && mats.length > 0) {
      return mats.map(String).filter(Boolean).sort((a, b) => a.localeCompare(b));
    }
    return Object.keys(materialEmissionsMap).sort((a, b) => a.localeCompare(b));
  }, [data, materialEmissionsMap]);

  return {
    metaData: data,
    metaLoading: loading,
    metaError: error,
    donorOptions,
    materialOptions,
    materialEmissionsMap,
  };
}
